<section [ngClass]="data.type" class="toaster">
  <div class="toaster-wrap d-flex">
    <div class="toaster-icon d-flex align-items-center justify-content-center">
      <img
        [src]="imageSettings[data.type].url"
        [style.height]="imageSettings[data.type].height || ''"
        [style.width]="imageSettings[data.type].width || ''"
        alt="icon"
      />
    </div>
    <div class="toaster-info">
      <p *ngIf="data.title" [innerHTML]="data.title | translate" class="title text-left"></p>
      <p *ngIf="data.content?.message" [translate]="'errors.' + data.content?.message" class="subtitle"></p>
      <p
        *ngIf="data.content?.loggerCode"
        [innerHTML]="'errors.unexpectedError' | translate : { code: data.content?.loggerCode } | sanitizeHtml"
        class="subtitle"
      ></p>
      <ng-container *ngIf="data.content?.errors?.length">
        <p *ngFor="let err of data.content?.errors" class="subtitle">
          <span [translate]="'client.' + err.field"></span>:
          <span [translate]="err.message" class="pl-1"></span>
        </p>
      </ng-container>
    </div>
    <div class="toaster-buttons">
      <div (click)="close()" class="toaster-btn cursor-pointer"></div>
    </div>
  </div>
</section>
